import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ArmazenamentoDeTokenService } from 'src/app/shared/services/armazenamento/armazenamento-de-token.service';
import { ToastService } from 'src/app/shared/services/utils/toast.service';
import { ValidacoesFormError } from '../erros/validacoes-form.error';
import { ArmazenamentoDeUsuarioService } from '../services/armazenamento/armazenamento-de-usuario.service';
import { transformarErros } from '../utils/transforma-validacoes';

@Injectable()
export class APIErroInterceptor implements HttpInterceptor {
  constructor(
    private armazenamentoDeTokenService: ArmazenamentoDeTokenService,
    private armazenamentoDeUsuarioService: ArmazenamentoDeUsuarioService,
    private toastService: ToastService,
    private router: Router
  ) {}

  intercept(
    requisicao: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(requisicao).pipe(
      tap((response: any) => {
        const body = response?.body;
        const usuarioDoGerenciamento = body?.user && body?.user?.portal == null;

        if (usuarioDoGerenciamento) {
          throw {
            error: {
              message: 'Ops! Login e/ou senha estão incorretos.',
            },
          };
        }

        const mensagem = body?.message;
        const status = body?.status;

        return mensagem && !status && this.mostrarMensagem(mensagem, 'sucesso');
      }),
      catchError((err) => {
        this.logarErroCorsOuRedeSeStatusZero(requisicao, err);

        const urlSemQuery = requisicao.url.split('?')[0];
        const isPostAuthLogin =
          requisicao.method === 'POST' && /\/login$/i.test(urlSemQuery);

        if (err.status === 401) {
          this.armazenamentoDeTokenService.removerToken();
          this.armazenamentoDeUsuarioService.removerUsuario();
          if (!isPostAuthLogin) {
            void this.router.navigate(['/auth/login'], {
              queryParams: { callback: 'sessao-expirada' },
              replaceUrl: false,
            });
          }
          return throwError(() => err);
        }

        if (err.status === 422 && err.error?.errors) {
          return throwError(
            () =>
              new ValidacoesFormError(
                transformarErros(err.error.errors),
                err.error.errors,
                err.error.message
              )
          );
        }

        if (err.status === 403 && err.error?.errors && isPostAuthLogin) {
          return throwError(
            () =>
              new ValidacoesFormError(
                transformarErros(err.error.errors),
                err.error.errors,
                err.error.message,
                403
              )
          );
        }

        if (err.status === 422 && !err.error?.errors) {
          if (!isPostAuthLogin) {
            this.mostrarMensagem(err?.error?.message);
          }
          return throwError(() => err);
        }

        if (!isPostAuthLogin) {
          this.mostrarMensagem(err?.error?.message);
        }
        return throwError(() => err);
      })
    );
  }

  /**
   * Status 0 = sem resposta HTTP (CORS, offline, certificado, etc.).
   * O browser só mostra o aviso de CORS; aqui reforçamos com console.error.
   */
  private logarErroCorsOuRedeSeStatusZero(
    requisicao: HttpRequest<any>,
    err: unknown
  ): void {
    const status =
      err instanceof HttpErrorResponse
        ? err.status
        : (err as { status?: number })?.status;
    if (status !== 0) {
      return;
    }

    const url = requisicao.url;
    const method = requisicao.method;
    const message =
      err instanceof HttpErrorResponse
        ? err.message
        : (err as { message?: string })?.message;
    const body =
      err instanceof HttpErrorResponse ? err.error : (err as { error?: unknown })?.error;

    console.error(
      '[HTTP] Falha de rede / provável CORS (status 0). Verifique Access-Control-* na API (inclua Authorization em Allow-Headers se usar Bearer) ou use proxy no ng serve.',
      { method, url, message, error: body }
    );
  }

  private mostrarMensagem(mensagem: any, tipo: 'erro' | 'sucesso' = 'erro') {
    this.toastService[tipo](
      `${
        mensagem && typeof mensagem == 'string'
          ? mensagem
          : tipo === 'erro'
          ? 'Algo não saiu como esperado. Tente novamente mais tarde.'
          : ''
      }`,
      '',
      {
        timeOut: 4000,
      }
    );
  }
}
